// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"ea71ea28","319":"7ba9393b","410":"399f52e8","440":"995c8b6e","455":"0e79f8bb","488":"07aeec02","593":"fbdcc109","612":"bf8a69eb","883":"192a5580","977":"903cdee8"}[chunkId] + ".chunk.js";
};